<template>
  <div class="admin-users-container">
    <div class="title">
      Usuarios
      <a class="csv-link" :href="exportData" download="results.csv">Descargar CSV</a>
    </div>
    <div class="stats" v-if="users">
      <div class="stat-card card-bg-1">
        <div class="stat-name">Usuarios registrados</div>
        <div class="stat-value">{{ users.length }}</div>
      </div>
      <div class="stat-card card-bg-2">
        <div class="stat-name">Inversionistas</div>
        <div class="stat-value">{{ investedUsers.length }}</div>
      </div>
      <div class="stat-card card-bg-3">
        <div class="stat-name">Total invertido</div>
        <div class="stat-value">{{ formatMoney(totalInvested) }}</div>
      </div>
    </div>
    <div class="card">
      <div class="search-bar">
        <div>Busqueda: <input v-model="searchValue" class="search-input"></div>
        <div class="filters">
          <div class="filter" @click="filter = 'all'">Todos</div>
          <div class="filter" @click="filter = 'verified'" style="margin-left: 15px">Verificados</div>
          <div class="filter" @click="filter = 'pending'" style="margin-left: 15px">Pendientes</div>
        </div>
      </div>
      <div class="user-list">
        <div class="list-headers">
          <div class="user-name">Nombre</div>
          <div class="user-name">Apellidos</div>
          <div class="user-investment">II</div>
          <div class="user-investment">IR</div>
          <div class="user-last">Verificación</div>
          <div class="user-creation">Registro</div>
        </div>
        <div
          class="user-card"
          v-for="user in filteredUsers"
          :key="user.id">
          <div class="user-name">{{ user.name }}</div>
          <div class="user-name">{{ user.lastName }}</div>
          <div class="user-investment">{{ user.preinvestments.length }}</div>
          <div class="user-investment">{{ user.investments.length }}</div>
          <div class="user-last">
            <div v-if="user.isLocked">
              <img src="@/assets/checked.svg">
            </div>
            <div v-else-if="verificationInfo(user) === '100.0%'">
              <img src="@/assets/information.svg">
            </div>
            <div v-else>
              <img src="@/assets/cross.svg">
            </div>
            {{ verificationInfo(user) }}
          </div>
          <div class="user-creation">{{ moment(user.created_at).format('MMM DD, YYYY') }}</div>
          <div class="user-interaction" @click="$router.push(`/admin/user/${user.id}`)">
            <img src="/view.svg" alt="" style="height:18px">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import formatMixin from '@/mixins/formatMixin';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('admin');

export default {
  data() {
    return {
      moment,
      exportData: '',
      searchValue: '',
      filter: 'all',
    };
  },
  mixins: [formatMixin],
  computed: {
    filteredUsers() {
      let result = this.users;
      if (this.searchValue) {
        const search = this.searchValue.toUpperCase();
        result = this.users.filter(user =>
          user.name.toUpperCase().includes(search) ||
          user.lastName.toUpperCase().includes(search) ||
          user.email.toUpperCase().includes(search));
      }
      switch (this.filter) {
        case 'all':
          return result;
        case 'verified':
          return result.filter(user => user.isLocked);
        case 'pending':
          return result.filter(user => this.verificationInfo(user) === '100.0%' && !user.isLocked);
        default:
          return result;
      }
    },
    investedUsers() {
      return this.users.filter(user => user.investments.length > 0);
    },
    totalInvested() {
      let total = 0;
      if (this.investedUsers && this.investedUsers.length > 0) {
        for (let i = 0; i < this.investedUsers.length; i += 1) {
          const element = this.investedUsers[i];
          for (let j = 0; j < element.investments.length; j += 1) {
            const investment = element.investments[j];
            total += parseInt(investment.investment, 10);
          }
        }
      }
      return total;
    },
    ...mapState([
      'users',
    ]),
  },
  methods: {
    stylizeNumber(number) {
      if (number) {
        return (number / 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return null;
    },
    fullInfo(user) {
      const attributes = [
        'name',
        'lastName',
        'birthday',
        'rfc',
        'curp',
        'nationality',
        'isQualifiedInvestor',
        'isPep',
        'isPepRelated',
        'workCompany',
        'averageIncome',
        'address',
        'settlement',
        'municipality',
        'state',
        'country',
        'postalCode',
        'phone',
        'officialIdUrl',
        'proofOfAdressUrl',
        'accountClabe',
      ];

      const total = attributes.length;
      let completed = 0;

      for (let i = 0; i < total; i += 1) {
        const value = user[attributes[i]];
        if (value !== null) {
          completed += 1;
        }
      }
      const percentage = (completed / total) * 100;
      return `${percentage.toFixed(1)}%`;
    },
    verificationInfo(user) {
      const attributes = [
        'birthday',
        'curp',
        'workCompany',
        'nationality',
        'isPep',
        'isPepRelated',
        'officialIdUrl',
        'isQualifiedInvestor',
      ];

      const total = attributes.length;
      let completed = 0;

      for (let i = 0; i < total; i += 1) {
        const value = user[attributes[i]];
        if (value !== null) {
          completed += 1;
        }
      }
      const percentage = (completed / total) * 100;
      return `${percentage.toFixed(1)}%`;
    },
    ...mapActions([
      'getUsers',
    ]),
  },
  mounted() {
    this.getUsers().then(() => {
      this.exportData += 'Nombre,Apellido(s),Correo electrónico,Fecha de cumpleaños,RFC,CURP,Nacionalidad,Inversionista Calificado,PEP,Relacionado a PEP,Compañia,Sueldo promedio,Dirección,Colonia,Delegación,Estado,Pais,Codigo Postal,Teléfono,CLABE,Fecha de registro\r\n';
      for (let i = 0; i < this.users.length; i += 1) {
        const element = this.users[i];
        this.exportData += `${element.name},${element.lastName},${element.email},${element.birthday},${element.rfc},${element.curp},${element.nationality},${element.isQualifiedInvestor},${element.isPep},${element.isPepRelated},${element.workCompany},${element.averageIncome},${element.address},${element.settlement},${element.municipality},${element.state},${element.country},${element.postalCode},${element.phone},${element.accountClabe},${element.created_at}\r\n`;
      }
      const blob = new Blob([this.exportData], { type: 'text/csv' });
      this.exportData = window.URL.createObjectURL(blob);
    });
  },
};
</script>

<style lang="scss" scoped>
// .admin-users-wrapper {
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   background-color: #ffffff;
//   min-height: 100vh;
//   font-family: "IBM Plex Sans", "Helvetica Neue", Arial, sans-serif;
// }
.admin-users-container {
  width: 100%;
  // padding-top: 100px;
  font-family: 'Inter';
  display: flex;
  flex-direction: column;
}
.title {
  font-size: 28px;
  margin-bottom: 30px;
  font-weight: bold;
  letter-spacing: 0.64px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  a {
    font-weight: 400;
    font-size: 16px;
    color: #2c70c1;
  }
}
.stats {
  display: flex;
  justify-content: space-between;
}
.stat-card {
  width: 32%;
  color: white;
  border-radius: 8px;
  padding: 20px;
}
.card-bg-1 {
  background: #fae8e7;
  color: #ef5841;
}
.card-bg-2 {
  background: #e5ebfb;
  color: #3479e9;
}
.card-bg-3 {
  background: #e6f5ee;
  color: #3fc67d;
}
.stat-name {
  font-size: 16px;
  margin-bottom: 6px;
  font-weight: 500;
}
.stat-value {
  font-size: 32px;
}
.card {
  border: 1px solid #e8e8e8;
  background-color: white;
  padding: 20px;
  border-radius: 6px;
  margin-top: 24px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.user-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  margin-bottom: 50px;
}
.user-card {
  width: 100%;
  padding: 16px 5px;
  background-color: white;
  border-radius: 5px;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.user-name {
  width: 22%;
}
.user-creation {
  width: 17%;
}
.user-investment {
  width: 10%;
  text-align: center;
}
.user-last {
  width: 17%;
  display: flex;

  div {
    width: 30%;
    img {
      height: 16px;
    }
  }
}
.user-interaction {
  height: 18px;
  display: flex;
  width: 4%;
  justify-content: flex-end;
  cursor: pointer;
}
.list-headers {
  color: black;
  display: flex;
  width: 100%;
  padding: 10px 5px 20px 5px;
  font-size: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  font-weight: bold;
}
.search-bar {
  width: 100%;
  display: flex;
  margin-top: 10px;
  align-items: center;
  padding: 0 5px;
  justify-content: space-between;
}
.search-input {
  border: 1px solid #DCDEDD;
  width: 350px;
  font-size: 16px;
  padding: 8px;
  margin-left: 14px;
}
.filters {
  display: flex;
}
.filter {
  margin-left: 15px;
  cursor: pointer;
}
@media only screen and (max-width: 840px) {
  .search-bar {
    flex-direction: column;
    align-items: flex-start;
  }
  .filters {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
  }
}
@media only screen and (max-width: 700px) {
  .user-investment {
    display: none;
  }
  .user-last {
    display: none;
  }
  .user-creation {
    display: none;
  }
  .user-name {
    width: 45%;
  }
  .stats {
    flex-direction: column;
  }
  .stat-card {
    width: 100%;
    margin: 10px 0;
  }
}
</style>
